import { useEffect, useRef, useState } from 'react';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, IconButton, ListItemIcon, ListItemText, MenuItem, Popover, Tooltip, Typography } from '@mui/material';
import useAuth from 'src/hooks/useAuth';

const languageOptions = {
  en: {
    icon: '/static/icons/uk-flag.svg',
    label: 'English',
  },
  nl: {
    icon: '/static/icons/netherlands-flag.svg',
    label: 'Dutch',
  },
};

const LanguagePopover: FC = () => {
  const anchorRef = useRef<HTMLButtonElement | null>(null);
  const { user } = useAuth();
  const { i18n } = useTranslation();
  const [open, setOpen] = useState<boolean>(false);
  const [locale, setLocale] = useState(user?.language || 'en');

  const handleOpen = (): void => {
    setOpen(true);
  };

  const handleClose = (): void => {
    setOpen(false);
  };

  const handleChangeLanguage = (language: string): void => {
    setLocale(language);
    setOpen(false);
  };

  const selectedOption = languageOptions[i18n.language];

  useEffect(() => {
    i18n.changeLanguage(locale);
  }, [locale]);
  return (
    <>
      <Tooltip title="Language" arrow>
        <IconButton
          onClick={handleOpen}
          ref={anchorRef}
        >
          <Box
            sx={{
              display: 'flex',
              height: 20,
              width: 20,
              '& img': {
                width: '100%',
              },
            }}
          >
            <img
              alt={selectedOption.label}
              src={selectedOption.icon}
            />
          </Box>
        </IconButton>
      </Tooltip>
      <Popover
        anchorEl={anchorRef.current}
        anchorOrigin={{
          horizontal: 'center',
          vertical: 'bottom',
        }}
        keepMounted
        onClose={handleClose}
        open={open}
        PaperProps={{
          sx: { width: 240 },
        }}
      >
        {Object.keys(languageOptions).map((language) => (
          <MenuItem
            onClick={() => handleChangeLanguage(language)}
            key={language}
          >
            <ListItemIcon>
              <Box
                sx={{
                  display: 'flex',
                  height: 20,
                  width: 20,
                  '& img': {
                    width: '100%',
                  },
                }}
              >
                <img
                  alt={languageOptions[language].label}
                  src={languageOptions[language].icon}
                />
              </Box>
            </ListItemIcon>
            <ListItemText
              primary={(
                <Typography
                  color="textPrimary"
                  variant="subtitle2"
                >
                  {languageOptions[language].label}
                </Typography>
              )}
            />
          </MenuItem>
        ))}
      </Popover>
    </>
  );
};

export default LanguagePopover;
